import React from 'react';

const GamesMoviesSection = ({ onOpenModal }) => {
  return (
    <section aria-labelledby="games-movies-title" className="mb-20">
      <div className="bg-gradient-to-br from-slate-50 via-white to-blue-50 rounded-xl border border-slate-200 shadow-lg site-card shadow-slate-200/70 overflow-hidden">
        <div className="p-8">
          <p className="text-sm font-semibold text-sky-700">Nova pagina</p>
          <div className="mt-2 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <div className="max-w-2xl">
              <h2
                id="games-movies-title"
                className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
              >
                Filmes para assistir, revisitar e guardar
              </h2>
              <p className="mt-4 text-lg text-gray-600">
                Um MVP da sua curadoria pessoal de cinema, com listas simples e espaco para evoluir
                com API depois.
              </p>
            </div>
            <button
              type="button"
              onClick={onOpenModal}
              className="inline-flex items-center justify-center rounded-md bg-slate-800 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-slate-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700"
            >
              Ver novidade
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GamesMoviesSection;
